import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeChargeCodes } from './normalize';

export const fetchChargeCodes = createProvider(api.fetchChargeCodes)
  .andThen((res) => normalizeChargeCodes(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch charge codes aborted');
    } else {
      console.error('Fetch charge codes was failed:', error);
    }
    throw error;
  });
